// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".video-container {\n  text-align: center;\n  padding-top: 2rem;\n  padding-bottom: 2rem;\n  grid-gap: 40px;\n  gap: 40px;\n  display: flex;\n  flex-direction: column;\n  /* space between videos */ }\n  .video-container iframe {\n    width: 100%; }\n", ""]);
// Exports
module.exports = exports;
